module.exports = __webpack_public_path__ + "static/cube17-19abd62871a659233fc72bf84a055c81.svg";